import 'swiper/swiper-bundle.css'

import { Swiper, SwiperSlide } from 'swiper/react'
import { css, keyframes } from '@emotion/react'
import { useRef, useState } from 'react'

import { BlogCard } from '@/src/components/Blog/BlogCard'
import BlogList from '@/src/components/Blog/BlogList'
import { Box } from '@mui/material'
import Footer from '@/src/components/Footer/Footer2'
import Header from '@/src/components/HeaderV2'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import { NextSeo } from 'next-seo'
import ToggleGroup from '@/src/components/Blog/ToggleGroup'
import { Typography } from '@evocolabs/orkaui'
import style from '@/pages/scss/HearingBlog.module.scss'
import { useSelector } from 'react-redux'

const data = {
  buttonMap: new Map(
    [
      { text: 'All', order: 0 },
      { text: 'News', order: 1 },
      { text: 'User Voice', order: 2 },
      { text: 'Orka Technology', order: 3 },
      { text: 'Hearing Health', order: 4 },
      { text: 'Knowledge & Tips', order: 5 }
    ].map((i) => [Object.values(i)[0], i.order])
  )
}

const Landing = () => {
  const swiperRef = useRef(null)
  const [page, setPage] = useState('1/2')

  const nextPage = () => {
    const swiper = swiperRef?.current?.swiper
    swiper?.slideNext()
    const index = swiper.activeIndex || 0
    setPage(`${index + 1}/2`)
  }
  const backPage = () => {
    const swiper = swiperRef?.current?.swiper
    swiper?.slidePrev()
    const index = swiper.activeIndex || 0
    setPage(`${index + 1}/2`)
  }

  const PageButton = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          zIndex: '999',
          mt: {
            xs: '40px',
            md: 'auto'
          },
          position: {
            xs: 'relative',
            md: 'absolute'
          },
          top: {
            md: '87%',
            xs: '0'
          },
          right: {
            md: '22.5%',
            xs: '0'
          },
          transform: {
            xs: '',
            md: 'translateX(50%)'
          }
        }}
      >
        <Typography
          style={{
            verticalAlign: 'middle',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <KeyboardBackspaceIcon
            id="hearingblog_hero_section_left_arrow"
            onClick={backPage}
            className={style['arrow-icon']}
            style={{
              color: !swiperRef?.current?.swiper?.activeIndex
                ? '#636363'
                : 'black'
            }}
          />
          &nbsp;{page}&nbsp;
          <KeyboardBackspaceIcon
            id="hearingblog_hero_section_right_arrow"
            onClick={nextPage}
            className={style['arrow-icon']}
            style={{
              transform: 'rotate(180deg)',
              color: !swiperRef?.current?.swiper?.activeIndex
                ? 'black'
                : '#636363'
            }}
          />
        </Typography>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        marginTop: '40px'
      }}
    >
      <Swiper
        ref={swiperRef}
        spaceBetween={0}
        slidesPerView={1}
        onSlideChange={(swiper) => {
          const index = swiper.activeIndex || 0
          setPage(`${index + 1}/2`)
        }}
        className={style['swiper-section']}
        speed={1000}
        // autoplay={{
        //   disableOnInteraction: false
        // }}
        observeParents
        observer
      >
        <SwiperSlide style={{ height: 'auto' }}>
          <Box
            className={style['swiper-wrapper']}
            onClick={() => {
              window.location.href = '/blogPage/orka-two'
            }}
          >
            <Box
              sx={{
                width: { xs: '100%', md: '55%' },
                paddingBottom: { xs: '75%', md: '50.5%' }
              }}
              style={{
                backgroundImage:
                  'url(https://legacy-cdn.hiorka.com/imgs/blog/shareImgs/blog_orka_two.png)',
                backgroundPosition: 'center',
                position: 'relative',
                overflow: 'hidden',
                backgroundSize: 'cover',
                borderRadius: '12px'
              }}
            />
            <div
              id="hearingblog_hero_section_Orka_Two_Lanuches"
              className={style['text-area']}
            >
              <Typography
                variant="body3"
                sx={{
                  borderRadius: '4px',
                  p: '4px 8px',
                  bgcolor: '#EFF1F5',
                  alignSelf: 'flex-start',
                  color: '#415670',
                  fontWeight: '600'
                }}
              >
                &nbsp;News
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  m: '16px 0 8px',
                  fontFamily: 'Merriweather',
                  fontWeight: '900',
                  fontSize: { xs: '24px', md: '32px' }
                }}
              >
                Orka Launches Orka Two, the Next-Generation Hearing Aid
              </Typography>
              <Typography variant="body2">
                Introducing Orka Two — the next-generation hearing aid using
                advanced technologies to enhance audio experiences.
              </Typography>
            </div>
          </Box>
        </SwiperSlide>
        <SwiperSlide style={{ height: 'auto' }}>
          <Box
            className={style['swiper-wrapper']}
            onClick={() => {
              window.location.href = '/blogPage/orka-two-prize'
            }}
          >
            <Box
              sx={{
                width: { xs: '100%', md: '55%' },
                paddingBottom: { xs: '75%', md: '50.5%' }
              }}
              style={{
                backgroundImage:
                  'url(https://legacy-cdn.hiorka.com/imgs/blog/shareImgs/blog_1007.jpg)',
                backgroundPosition: 'center',
                position: 'relative',
                overflow: 'hidden',
                backgroundSize: 'cover',
                borderRadius: '12px'
              }}
            />
            <div
              id={`hearingblog_hero_section_
                    AI_Denoise_Technology_
                    Orka_Strikes_Silver_and_Bronze_in_International_Signal_Processing_Challenges`}
              className={style['text-area']}
            >
              <Typography
                variant="body3"
                sx={{
                  borderRadius: '4px',
                  p: '4px 8px',
                  bgcolor: '#EFF1F5',
                  alignSelf: 'flex-start',
                  color: '#415670',
                  fontWeight: '600'
                }}
              >
                &nbsp;Orka Technology
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  m: '16px 0 8px',
                  fontFamily: 'Merriweather',
                  fontWeight: '900',
                  fontSize: { xs: '24px', md: '32px' }
                }}
              >
                Orka Strikes Silver and Bronze in International Signal
                Processing Challenges
              </Typography>
              <Typography variant="body3">
                Orka's research team has achieved significant accomplishments in
                the Second Clarity Enhancement Challenge (CEC2), and the Silver
                Prize...
              </Typography>
            </div>
          </Box>
        </SwiperSlide>
        <PageButton />
      </Swiper>
    </Box>
  )
}

const MostPopular = ({ blogInfo }) => {
  return (
    <Box
      display="flex "
      maxWidth={{ xs: 'initial', md: '82vw' }}
      m={{ xs: '80px 0 0 0', md: '96px auto 0 auto' }}
      flexDirection={{ xs: 'column-reverse', md: 'row' }}
    >
      <Box
        sx={{
          margin: 'auto',
          maxWidth: '1176px',
          justifyContent: 'flex-start',
          flex: { xs: '90vw', md: 1 },
          width: { xs: '90vw', md: 'auto' }
        }}
      >
        <Typography variant="h2">Most Popular</Typography>
        <Box
          display="flex"
          mt={{ xs: '16px', md: '24px' }}
          mb={{ xs: '24px', md: '70px' }}
          flexDirection={{ xs: 'column', md: 'row' }}
        >
          {blogInfo.map((item, index) => {
            return (
              <Box
                key={index}
                width={{ xs: '100%', md: '33.33%' }}
                className={style['card']}
              >
                <BlogCard item={item} />
              </Box>
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}

const BlogContext = ({ blogInfo, headerHeight }) => {
  const blogListRef = useRef(null)
  const toggleType = (type) => {
    blogListRef.current.toggleType(type)
  }
  const buttonInfo = [...new Set(blogInfo.map((i) => i.theme))].map((i) => ({
    text: i.replaceAll(
      /\w+/g,
      (s) => s[0].toUpperCase() + s.slice(1).toLowerCase()
    ),
    key: i.toUpperCase()
  }))
  buttonInfo.unshift({ text: 'All', key: 'ALL' })
  buttonInfo.sort((a, b) => {
    const orderA = data.buttonMap.has(a.text)
      ? data.buttonMap.get(a.text)
      : buttonInfo.indexOf(a)
    const orderB = data.buttonMap.has(b.text)
      ? data.buttonMap.get(b.text)
      : buttonInfo.indexOf(b)
    return orderA - orderB
  })
  return (
    <>
      <Box
        className="blog-list-toggle-group"
        bgcolor="#FCFCFD"
        sx={{
          position: 'sticky',
          top: `${headerHeight}px`,
          zIndex: 1,
          m: { xs: '0', md: '0 auto' },
          p: '24px 0',
          order: { xs: 2, md: 0 }
        }}
      >
        <Box
          width={{ xs: 'min(1176px, 90vw)', md: 'min(1176px, 82vw)' }}
          sx={{ margin: 'auto', mt: '24px' }}
        >
          <Typography variant="h2" sx={{ mb: '16px' }}>
            Latest from Orka
          </Typography>
          <ToggleGroup buttonInfo={buttonInfo} callback={toggleType} />
        </Box>
      </Box>
      <Box
        className="blog-list-container-box"
        display="flex"
        width="100%"
        maxWidth={{ xs: 'initial', md: 'min(1176px, 82vw)' }}
        m={{ xs: '0', md: '0px auto 0 auto' }}
        flexDirection={{ xs: 'column', md: 'column' }}
        position={{ xs: 'relative', md: 'relative' }}
      >
        <Box
          sx={{
            margin: { xs: 'auto', md: '0' },
            maxWidth: '1176px',
            justifyContent: 'flex-start',
            flex: { xs: '90vw', md: 1 },
            width: { xs: '90vw', md: 'auto' },
            order: { xs: 3, md: 0 }
          }}
        >
          <Box
            display="flex"
            mt={{ xs: '16px', md: '24px' }}
            mb={{ xs: '24px', md: '70px' }}
          >
            <BlogList
              dataProvider={blogInfo}
              buttonMap={buttonInfo}
              ref={blogListRef}
            />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export async function getStaticProps() {
  const res = await fetch(process.env.NEXT_PUBLIC_BASEURL + 'blog')
  const data = await res.json()

  return { props: { data }, revalidate: 600 }
}

export default function HearingBlog({ data }) {
  const headerHeight = useSelector((state) => state.header.height)

  // Function to extract the timestamp from the object
  const getTimestamp = (item) => {
    return new Date(item.write_time)
  }
  const sortedData = data.data.sort((a, b) => getTimestamp(b) - getTimestamp(a))
  // const mostPopularData = sortedData.filter((item) => item.is_popular === 1)
  // TODO: since backend is not ready, so hard code the most popular data for now
  const mostPopularData = data.data
    .filter((item) => item.id === 1005 || item.id === 1002 || item.id === 1003)
    .sort((a, b) => {
      const order = [1005, 1002, 1003]
      return order.indexOf(a.id) - order.indexOf(b.id)
    })

  const loaderKeyFrame = keyframes`
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  `
  const loaderAnimation = css`
    animation: ${loaderKeyFrame} 1s;
  `

  return (
    <Box style={{ width: '100%', overflow: 'clip' }}>
      <NextSeo
        title="Hearing Loss Tips & Information | Orka Hearing Aids"
        description="Stay up-to-date with the latest news and developments in the hearing industry, and get professional advice on hearing care and hearing aids usage. A better hearing that's all in your control."
      />
      <Header isWhiteBg />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: '#FCFCFD'
        }}
        id="container"
      >
        <div css={loaderAnimation} style={{ width: '100%' }}>
          <Landing blogInfo={sortedData} />
          <MostPopular blogInfo={mostPopularData.slice(0, 3)} />
          <BlogContext blogInfo={sortedData} headerHeight={headerHeight} />
        </div>
      </Box>
      <Footer />
    </Box>
  )
}

export { data }
